import { render, staticRenderFns } from "./CatalogueProductInformations.vue?vue&type=template&id=6d3ededd&scoped=true"
import script from "./CatalogueProductInformations.vue?vue&type=script&lang=js"
export * from "./CatalogueProductInformations.vue?vue&type=script&lang=js"
import style0 from "./CatalogueProductInformations.vue?vue&type=style&index=0&id=6d3ededd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ededd",
  null
  
)

export default component.exports